import { jsx } from 'react/jsx-runtime';
import { IconBase } from '../../icon-base/index.js';

const LoaderIndicator = (props) => (jsx(IconBase, Object.assign({}, props, { svgContent: jsx("path", { d: "M10.8,21.6C4.84,21.6,0,16.76,0,10.8S4.84,0,10.8,0c.75,0,1.35.6,1.35,1.35s-.6,1.35-1.35,1.35C6.33,2.7,2.7,6.33,2.7,10.8s3.63,8.1,8.1,8.1,8.1-3.63,8.1-8.1c0-.75.6-1.35,1.35-1.35s1.35.6,1.35,1.35c0,5.96-4.84,10.8-10.8,10.8Z" }), iconName: "loader-indicator", viewBox: "0 0 21.6 21.6" })));
LoaderIndicator.displayName = 'VDS_Icon';

export { LoaderIndicator as default };
